import {Component, ViewChild} from "@angular/core";
import {Client} from "src/app/services/API/client";
import {toastrService} from "src/app/services/ux/toastr.service";
import {Router} from "@angular/router";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";
import {AddContractComponent} from "src/app/common/components/modal/modal-add-contract-content/modal-add-contract-content.component";
import {FinServiceHttpClientService} from "../../data/fin-service-http-client.service";
import {FinService} from "../../models/FinService/fin-service";
import {UserHttpClientService} from "../../data/user-http-client.service";
import {ChipsSearchComponent} from "./chips-search/chips-search.component";

@Component({
    templateUrl: "myContracts.component.html"
})
export class MyContractsComponent {
    @ViewChild(AddContractComponent)
    private AddContractComponent: AddContractComponent;

    hasResults = false;
    isLoading = false;
    filteredRecords: any;
    records: any;

    selectedService: any;
    selectedContract: any;
    invoiceIndex: any;
    selectedInvoice: any;

    finServiceRecords = [] as FinService[];

    private _searchFilters = [] as string[];

    @ViewChild(ChipsSearchComponent) element: ChipsSearchComponent;

    constructor(
        private client: Client,
        private toastr: toastrService,
        private router: Router,
        private modal: ModalPaymentService,
        private finServiceHttpClient: FinServiceHttpClientService,
        private userHttpClient: UserHttpClientService
    ) {
        this.getContracts();
        this.getFinServices();
    }

    public updateFilters(value: {
        action: string,
        chipName: string
    }) {
        switch (value.action) {
            case "+":
                this._searchFilters.push(value.chipName.toLowerCase());
                this.filterRecords();
                break;
            case "-":
                const index = this._searchFilters.indexOf(value.chipName.toLowerCase());
                this._searchFilters.splice(index, 1);

                this.filterRecords();
                break;
        }
    }

    getContracts() {
        this.isLoading = true;

        this.userHttpClient.getContracts().subscribe(
            {
                next: contracts => {
                    this.records = contracts;
                    this.filteredRecords = contracts;
                    this.hasResults = true;
                    this.isLoading = false;
                    this.setImageUrlForContracts();
                },
                error: err => {
                    this.toastr.warning(err.error);
                    this.isLoading = false;
                }
            }
        );
    }

    private getFinServices() {
        this.finServiceHttpClient.getFinServices()
            .then(value => {
                this.finServiceRecords = value;
            })
            .catch(reason => {
                this.toastr.warning("Ndodhi nje problem me marrjen e sherbimeve.");
            });
    }

    setImageUrlForContracts() {
        this.filteredRecords.forEach((record) => {
            switch (record.serviceName) {
                case "OSHEE":
                    record["imageUrl"] = "./assets/img/payments/oshee.png";
                    break;
                case "DOGANA":
                    record["imageUrl"] = "./assets/img/payments/dogana.png";
                    break;
                case "UKT":
                    record["imageUrl"] = "./assets/img/payments/ukt.png";
                    break;
                case "GJOBA":
                    record["imageUrl"] = "./assets/img/payments/gjoba.png";
                    break;
                case "ZRPP":
                    record["imageUrl"] = "./assets/img/payments/zrpp.png";
                    break;
                case "TATIME":
                    record["imageUrl"] = "./assets/img/payments/tatime.png";
                    break;
                case "ALBTELECOM":
                    record["imageUrl"] = "./assets/img/payments/albtelecom.png";
                    break;
                case "ONE":
                    record["imageUrl"] = "./assets/img/payments/one.png";
                    break;
                case "KINDERGARDEN":
                    record["imageUrl"] = "./assets/img/payments/kindergarden.png";
                    break;
                case "ALBTELECOMCONTRACT":
                    record["imageUrl"] = "./assets/img/payments/albtelecom.png";
                    break;
                default:
                    record["imageUrl"] = "./assets/img/payments/oshee.png";
                    break;
            }
        });
    }

    navigateToSavedSherbim(index) {
        this.selectedInvoice = this.filteredRecords[index];
        const urlParams = JSON.parse(JSON.stringify(this.selectedInvoice));
        delete urlParams["contractId"];
        delete urlParams["contractName"];
        delete urlParams["fieldLabel"];
        delete urlParams["serviceName"];
        delete urlParams["imageUrl"];

        this.router.navigate([
            `/services/${this.selectedInvoice.serviceName.toLowerCase()}`,
            urlParams
        ]);
    }

    filterRecords() {
        if (this._searchFilters.length === 0) {
            this.filteredRecords = this.records;
            return;
        }
        this.filteredRecords = this.records.filter(
            (record) => {
                return this._searchFilters.includes(record.serviceName.toLowerCase());
            }
        );
    }

    editContract(serviceName, index) {
        this.selectedContract = this.filteredRecords[index];
        this.getServiceByName(serviceName);
        this.modal.open();
    }

    private getServiceByName(serviceName) {
        return this.client
            .get(`api/services/${serviceName}`)
            .then((res) => {
                this.selectedService = res;
                this.AddContractComponent.updateContract(this.selectedContract);
                this.AddContractComponent.selectService(res);
            })
            .catch((error) => {
                return null;
            });
    }

    deleteContract(index) {
        this.invoiceIndex = index;
        this.selectedInvoice = this.filteredRecords[index];
        if (confirm("Jeni te sigurte qe doni ta fshini kete kontrate?")) {
            this.client
                .delete("api/contracts/" + this.selectedInvoice.contractId)
                .then((res) => {
                    this.toastr.success("Kontrata u fshi me sukses");
                    this.filteredRecords.splice(this.invoiceIndex, 1);
                    this.records = this.records.filter(
                        (q) => q.contractId !== this.selectedInvoice.contractId
                    );
                })
                .catch((error) => {
                    this.toastr.warning(error.error);
                });
        }
    }
}
